import React from 'react';
import { motion } from 'framer-motion';

const Gallery = () => {
  const images = [
    { src: "/images/tajmahal.jpg", span: "col-span-1 md:col-span-2 row-span-2", alt: "Taj Mahal" },
    { src: "/images/bali.jpg", span: "col-span-1", alt: "Bali Temple" },
    { src: "/images/paris2.jpg", span: "col-span-1", alt: "Paris Eiffel" },
    { src: "/images/mecca.jpg", span: "col-span-1 md:col-span-2", alt: "Mecca Pilgrimage" },
  ];

  return (
    <section id="gallery" className="py-32 bg-white">
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8">
          <div>
            <div className="flex items-center gap-4 mb-4">
              <div className="w-8 h-px bg-accent"></div>
              <span className="text-accent font-medium tracking-[0.2em] uppercase text-xs">Jejak Langkah</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-serif text-slate-900">
              Momen Abadi
            </h2>
          </div>
          <a href="#services" className="text-primary font-medium uppercase tracking-widest text-sm hover:text-accent transition-colors flex items-center gap-2">
            Lihat Semua <span className="text-lg">→</span>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 auto-rows-[250px]">
          {images.map((img, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className={`relative overflow-hidden group rounded-sm ${img.span}`}
            >
              <img 
                src={img.src} 
                alt={img.alt} 
                className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" 
              />
              <div className="absolute inset-0 bg-slate-900/20 group-hover:bg-slate-900/40 transition-colors duration-500"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;